module.exports = __webpack_public_path__ + "static/img/news1_4.915472d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news1_4.png
// module id = oW+R
// module chunks = 0